import React from 'react';
import { LoginCard } from '../components/auth/LoginCard';
import { Header } from '../components/layout/Header';
import { Footer } from '../components/layout/Footer';
interface LandingPageProps {
  onLogin: () => void;
}
export function LandingPage({
  onLogin
}: LandingPageProps) {
  return <div className="flex flex-col min-h-screen bg-gradient-to-b from-gray-50 to-gray-100" data-id="element-728">
      <Header isAuthenticated={false} onLogout={() => {}} data-id="element-729" />
      <main className="flex-grow" data-id="element-730">
        <div className="container mx-auto px-4 py-12 md:py-20" data-id="element-731">
          <div className="flex flex-col md:flex-row items-center justify-between gap-12" data-id="element-732">
            <div className="w-full md:w-1/2 space-y-6" data-id="element-733">
              <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#1A1F36] leading-tight" data-id="element-734">
                Welcome to EthBridge Bank Portal
              </h1>
              <p className="text-lg text-gray-600" data-id="element-735">
                Your comprehensive banking solution for secure transactions,
                account management, and real-time financial monitoring across
                Ethiopia's banking network.
              </p>
              <div className="flex flex-wrap gap-4 pt-4" data-id="element-736">
                <div className="flex items-center bg-white p-3 rounded-lg shadow-sm border border-gray-200" data-id="element-737">
                  <div className="rounded-full bg-blue-100 p-2 mr-3" data-id="element-738">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-blue-600" viewBox="0 0 20 20" fill="currentColor" data-id="element-739">
                      <path fillRule="evenodd" d="M6.672 1.911a1 1 0 10-1.932.518l.259.966a1 1 0 001.932-.518l-.26-.966zM2.429 4.74a1 1 0 10-.517 1.932l.966.259a1 1 0 00.517-1.932l-.966-.26zm8.814-.569a1 1 0 00-1.415-1.414l-.707.707a1 1 0 101.415 1.415l.707-.708zm-7.071 7.072l.707-.707A1 1 0 003.465 9.12l-.708.707a1 1 0 001.415 1.415zm3.2-5.171a1 1 0 00-1.3 1.3l4 10a1 1 0 001.823.075l1.38-2.759 3.018 3.02a1 1 0 001.414-1.415l-3.019-3.02 2.76-1.379a1 1 0 00-.076-1.822l-10-4z" clipRule="evenodd" data-id="element-740" />
                    </svg>
                  </div>
                  <span className="text-sm font-medium" data-id="element-741">
                    Fast & Secure Transactions
                  </span>
                </div>
                <div className="flex items-center bg-white p-3 rounded-lg shadow-sm border border-gray-200" data-id="element-742">
                  <div className="rounded-full bg-green-100 p-2 mr-3" data-id="element-743">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-green-600" viewBox="0 0 20 20" fill="currentColor" data-id="element-744">
                      <path fillRule="evenodd" d="M2.166 4.999A11.954 11.954 0 0010 1.944 11.954 11.954 0 0017.834 5c.11.65.166 1.32.166 2.001 0 5.225-3.34 9.67-8 11.317C5.34 16.67 2 12.225 2 7c0-.682.057-1.35.166-2.001zm11.541 3.708a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-745" />
                    </svg>
                  </div>
                  <span className="text-sm font-medium" data-id="element-746">
                    Real-time Monitoring
                  </span>
                </div>
                <div className="flex items-center bg-white p-3 rounded-lg shadow-sm border border-gray-200" data-id="element-747">
                  <div className="rounded-full bg-orange-100 p-2 mr-3" data-id="element-748">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-orange-600" viewBox="0 0 20 20" fill="currentColor" data-id="element-749">
                      <path d="M13 6a3 3 0 11-6 0 3 3 0 016 0zM18 8a2 2 0 11-4 0 2 2 0 014 0zM14 15a4 4 0 00-8 0v3h8v-3zM6 8a2 2 0 11-4 0 2 2 0 014 0zM16 18v-3a5.972 5.972 0 00-.75-2.906A3.005 3.005 0 0119 15v3h-3zM4.75 12.094A5.973 5.973 0 004 15v3H1v-3a3 3 0 013.75-2.906z" data-id="element-750" />
                    </svg>
                  </div>
                  <span className="text-sm font-medium" data-id="element-751">
                    Multi-Channels Integration
                  </span>
                </div>
              </div>
            </div>
            <div className="w-full md:w-1/2 max-w-md" data-id="element-752">
              <LoginCard onLogin={onLogin} data-id="element-753" />
            </div>
          </div>
        </div>
      </main>
      <Footer data-id="element-754" />
    </div>;
}